var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape24 = function SvgShape24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M146.382 75.999c12.242 22.816 2.993 43.471-20.613 49.767-6.298 23.609-26.954 32.855-49.77 20.616-22.816 12.241-43.471 2.993-49.767-20.614C2.626 119.47-6.623 98.815 5.618 75.998c-12.24-22.815-2.992-43.47 20.614-49.766C32.528 2.625 53.183-6.623 76 5.618c22.816-12.241 43.472-2.993 49.767 20.614 23.609 6.295 32.855 26.95 20.616 49.767",
    opacity: 0.1
  })));
};
export default SvgShape24;